import { ClientDispatcher } from './index';
export var CLIENT_DISPATCHER_MODULE = 'ClientDispatcher';
var dispatcher;
export var getClientDispatcher = function getClientDispatcher() {
  if (!dispatcher) {
    dispatcher = new ClientDispatcher();
    // Handle the server hangup scenarios
    dispatcher.register(CLIENT_DISPATCHER_MODULE, dispatcher._abort.bind(dispatcher));
  }
  return dispatcher;
};